import "core-js/modules/es.array.push.js";
import useAbility from '@/plugins/useAbility';
import { USER_ACTIONS } from '@/utils/const';
export default {
  name: 'SidebarSimpleItem',
  props: {
    title: {
      type: String,
      required: true
    },
    routerTo: {
      type: Object
    },
    icon: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    iconClass: {
      type: String,
      default: ''
    },
    ability: {
      type: Object
    },
    showLock: {
      type: Boolean,
      default: false
    },
    viewBox: {
      type: String,
      default: '0 0 24 24'
    }
  },
  computed: {
    lockedItem() {
      return this.ability ? !this.can(USER_ACTIONS.READ, this.ability?.subject) : false;
    },
    disabled() {
      return this.showLock && this.lockedItem;
    },
    isCurrentRoute() {
      return this.$route.name === this.routerTo.name && (this.routerTo.hash === undefined || this.routerTo.hash === this.$route.hash);
    }
  },
  methods: {
    can(action, subject) {
      return useAbility().can(action, subject);
    },
    onLinkClick(e) {
      if (this.disabled || this.isCurrentRoute) {
        e.preventDefault();
        return;
      }
      this.$router.push(this.routerTo);
    }
  }
};